import React from 'react';
import { Box, MediaItem, useOptionalVideo, Image } from '@honda-canada/design-system-react';
import themeStyles from './TimelineSharedUI.styles';
import { getVideoProps } from '../../../utils/sitecoreFields';
var MediaContainer = themeStyles.apply(Box, 'MediaContainer');
var TimelineMediaContent = function (_a) {
    var mediaImage = _a.mediaImage, videoUrl = _a.videoUrl;
    var _b = mediaImage || {}, src = _b.src, alt = _b.alt;
    var video = getVideoProps(videoUrl, 'play video', 'close video modal', 'play video');
    var optionalVideo = useOptionalVideo(video).optionalVideo;
    if (!((mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src) || videoUrl))
        return null;
    var image = (React.createElement(Image, { height: ['200px', '600px'], width: ['100%', '540px'], maxWidth: "100%", "data-testid": "cy-text-content-media", src: src, alt: alt }));
    return (React.createElement(MediaContainer, null,
        React.createElement(MediaItem, { image: image, video: optionalVideo })));
};
export default TimelineMediaContent;
